import dayjs from 'dayjs';
import { Filters } from 'react-table';

import { MinMaxStringValues } from '../../../../apis/graphql/types';
import { DateRangeFilter } from '../../../../components/BlueTheme/Filter';
import { defaultDateFormatForBeServices } from '../../../../constants/dates';
import { getYesterday } from '../../Reports/ReportFilterModal/utils';
import { LINE_ITEM_START_DATE_COLUMN_ID } from '../constants';

type Props = {
  filters: Filters<{}>;
  filterValue: MinMaxStringValues;
  setFilter: (value?: MinMaxStringValues) => void;
  onFilterChanged: (value?: MinMaxStringValues) => void;
};

const LineEndFilter = ({ filters, filterValue, setFilter, onFilterChanged }: Props): JSX.Element => {
  const startDateRangeFilter = filters.find(({ id }) => id === LINE_ITEM_START_DATE_COLUMN_ID);
  const minAllowedMaxDate = startDateRangeFilter?.value?.max
    ? dayjs(startDateRangeFilter.value.max, { format: defaultDateFormatForBeServices }).toDate()
    : undefined;
  const handleFilter = (value?: MinMaxStringValues): void => {
    onFilterChanged(value);
    setFilter(value);
  };
  const countError = (dates: [Date | null, Date | null]): string | null => {
    if (!minAllowedMaxDate || !dates[1]) return null;
    return dates[1] < minAllowedMaxDate
      ? 'The end date must be greater than the end date for the Line Start Date filter.'
      : null;
  };
  return (
    <DateRangeFilter
      elementId="lineEndFilter"
      additionalText="Ends"
      choosenDateRange={filterValue}
      maxDate={getYesterday()}
      onChange={handleFilter}
      showError={countError}
    />
  );
};

export default LineEndFilter;
